import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { X } from "lucide-react";
import { useLang } from "@/i18n/LanguageProvider";
import { alternatePath } from "@/lib/routes";

const KEY = "lang-banner-dismissed";

// One-time, dismissible banner. No IP redirect — only offered if browser is English.
export function LanguageBanner() {
  const { lang } = useLang();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (lang !== "el") return;
    if (localStorage.getItem(KEY)) return;
    const browser = (navigator.language || "").toLowerCase();
    if (browser.startsWith("en")) setShow(true);
  }, [lang]);

  const dismiss = () => {
    localStorage.setItem(KEY, "1");
    setShow(false);
  };

  const goEnglish = () => {
    localStorage.setItem(KEY, "1");
    setShow(false);
    navigate(alternatePath(pathname, "en"));
  };

  if (!show) return null;

  return (
    <div className="border-b border-line bg-beige-soft" data-testid="language-banner">
      <div className="container-max flex flex-wrap items-center justify-center gap-3 py-2.5 text-[14px] text-ink">
        <span>Continue in English?</span>
        <button
          onClick={goEnglish}
          data-testid="banner-switch-en"
          className="inline-flex min-h-11 items-center rounded-full bg-petrol px-4 text-[13px] font-semibold text-white hover:bg-petrol-dark"
        >
          Switch to English
        </button>
        <button
          onClick={dismiss}
          data-testid="banner-dismiss"
          className="inline-flex min-h-11 items-center gap-1 text-[13px] text-ink-soft hover:text-ink"
        >
          No, thanks <X className="h-3.5 w-3.5" />
        </button>
      </div>
    </div>
  );
}
